import React from 'react'
import { Card, CardContent, Container, Typography } from '@material-ui/core'
import Page from '../../Page'
import { FORM_ACTIONS } from 'src/utils/constants/general'
import ErrorsValidation from '../../shared/displayErrorsValidations'
import FormFAQ from './shared/form'
import PageContainer from 'src/containers/shared/PageContainer';

const AddFAQ = (props) => {
  const {
    errors,
    loading,
    addFAQ,
  } = props;

  return (
    <PageContainer title="Agregar FAQ" maxWidth={false}>
        <Typography
          color="textPrimary"
          variant="h2"
          className="mb-3"
        >
          Agregando FAQ
        </Typography>
        <ErrorsValidation errors={errors} />
        <Card>
          <CardContent>
            <FormFAQ
              action={FORM_ACTIONS.ADD}
              addFAQ={addFAQ}
              loading={loading}
            />
          </CardContent>
        </Card>
    </PageContainer>
  )
}

export default AddFAQ
